"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const integrationSchema = new mongoose_1.Schema({
    user_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
        default: null,
        required: true,
    },
    team_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Team",
        default: null,
        required: false,
    },
    name: {
        type: String,
        enum: Object.values(enum_1.INTEGRATION_PROVIDERS),
        required: true,
    },
    app_id: String,
    hook: String,
    scope_description: Array,
    reference: String,
    type: {
        type: String,
        enum: Object.values(enum_1.INTEGRATION_TYPES),
        required: true,
    },
    token: String,
    extra: Object,
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("Integration", integrationSchema);
